import React from 'react';
import { Loading2, SearchLoop } from 'assets/icons';
import StyledInput from 'components/styledInput/StyledInput';

const AdminSearchInput = React.forwardRef(({
  value,
  onChange,
  placeholder = 'Rechercher...',
  highlightContent = null,
  imgBack = null,
  isLoading = false,
  variant = 'styled',
  className = '',
  inputClassName = '',
}, ref) => {
  const resolvedHighlight = highlightContent;
  const resolvedImgBack = imgBack ?? null;

  if (variant === 'command') {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <SearchLoop wh={20} color="#9CA3AF" />
        <div className="relative flex-1">
          <input
            ref={ref}
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`w-full text-base outline-none placeholder:text-gray-400 ${
              resolvedHighlight ? 'text-transparent caret-gray-900' : ''
            } ${inputClassName}`}
          />
          {resolvedHighlight && (
            <div
              className="absolute inset-0 pointer-events-none whitespace-pre text-base"
              aria-hidden
            >
              {resolvedHighlight}
            </div>
          )}
        </div>
        {resolvedImgBack}
        {isLoading && (
          <div className="animate-spin">
            <Loading2 wh={18} color="#FF9600" />
          </div>
        )}
      </div>
    );
  }

  return (
    <StyledInput
      type="text"
      placeholder={placeholder}
      imgFront={<SearchLoop wh={16} color="#6B7280" />}
      imgBack={resolvedImgBack}
      highlightContent={highlightContent !== null ? resolvedHighlight : undefined}
      value={value}
      onChange={onChange}
      className={className}
    />
  );
});

export default AdminSearchInput;
